import axios from 'axios';
import { t } from 'i18next';
import { endpoints } from '../../utils/constants';

export const getInvoicesByDivision = (
  accountNumbers,
  fromDate,
  toDate,
) =>
  axios.get(`${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.invoices.getInvoices}`, {
    headers: {
      accountNumbers,
    },
    params: {
      fromDate,
      toDate,
    },
  });

export const getInvoiceDocument = (invoiceNumber, invoiceType) =>
  axios.get(
    `${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.invoices.downloadInvoice}`, {
      params: {
        invoiceId: invoiceNumber,
        invoiceType,
      },
    },
  );

export const getInvoiceReports = (
  accountNumbers,
  fromDate,
  toDate,
  language,
) =>
  axios.get(`${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.invoices.exportInvoices}`, {
    headers: {
      accountNumbers,
    },
    params: {
      fromDate,
      toDate,
      language,
    },
  });
